import { RootState } from "../rootReducer";

export const selectIsLoading = (state: RootState) => state.updateUser.loading;
export const userAttendanceErrorMessage = (state: RootState) =>
  state.userAttendance.error;
export const userAttendanceSuccessResponse = (state: RootState) =>
  state.userAttendance.userAttendanceResponse;
